function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    const sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
    if (sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / sliderItemsToShow[0].clientWidth);
    this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderLastItem.clientWidth : this.slider.scrollLeft - this.sliderLastItem.clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  connectedCallback() {
    this.updateOptionAvailability();
  }

  onVariantChange() {
    this.checkForQuickview();
    this.updateOptions();
    this.updateMasterId();
    this.updateOptionAvailability();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    window.dispatchEvent(new CustomEvent("loft:Product:Variant__Changed", {
      detail: this.currentVariant
    }));

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  checkForQuickview(){
    let quickviewContainer = document.querySelectorAll('[data-is-quickview="true"]');
    if(quickviewContainer.length > 0){
      this.productContainerId = `${this.dataset.section}-quickview`;
    } else {
      this.productContainerId = `${this.dataset.section}`;
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return variant.options.every((option, index) => {
        return this.options[index] === undefined || this.options[index] === option;
      });
    });
  }

  // Annotate each <option> with sold-out/unavailable state for the variant it
  // would resolve to given the other selects' current values.
  updateOptionAvailability() {
    const selects = Array.from(this.querySelectorAll('select'));
    if (!selects.length) return;
    let variants;
    try { variants = this.getVariantData(); } catch (e) { return; }
    const selected = selects.map((select) => select.value);
    const strings = window.variantStrings || {};
    selects.forEach((select, index) => {
      Array.from(select.options).forEach((option) => {
        if (!option.dataset.baseLabel) option.dataset.baseLabel = option.textContent.trim();
        const candidate = selected.slice();
        candidate[index] = option.value;
        const match = variants.find((variant) =>
          variant.options.every((value, i) => value === candidate[i])
        );
        let label = option.dataset.baseLabel;
        if (!match) {
          label += ` - ${strings.unavailable || 'Unavailable'}`;
        } else if (!match.available) {
          label += ` - ${strings.soldOut || 'Sold out'}`;
        }
        if (option.textContent !== label) option.textContent = label;
      });
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );

    if (!newMedia) return;
    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    const parent = newMedia.parentElement;
    if (parent.firstChild == newMedia) return;
    modalContent.prepend(newMediaModal);
    parent.prepend(newMedia);
    this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
    if(this.stickyHeader) {
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }
    window.setTimeout(() => {
      parent.scrollLeft = 0;
      parent.querySelector('li.product__media-item').scrollIntoView({behavior: 'smooth'});
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {

    const productForms = document.querySelectorAll(`#product-form-${this.productContainerId}, #product-form-installment`);
    productForms.forEach((productForm) => {
      if(productForm.getAttribute('data-location') === 'subscription-master') return;
      
      const input = productForm.querySelector('input[name="id"]');
      const selling_plan_input = productForm.querySelector('input[name="selling_plan"]');
      
      input.value = this.currentVariant.id;
      
      if (selling_plan_input && this.currentVariant.selling_plan_allocations.length > 0) {
        selling_plan_input.value = this.currentVariant.selling_plan_allocations[0].selling_plan_id;
        selling_plan_input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {

        const id = `price-${this.productContainerId}`;
        const inventoryId = `inventory-${this.productContainerId}`;
        const skuId = `sku-${this.productContainerId}`;
        const price = document.getElementById(`price-${this.productContainerId}`);

        const html = new DOMParser().parseFromString(responseText, 'text/html')

        // Price
        const destination = document.getElementById(id);
        const source = html.getElementById(`price-${this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;
        
        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);

        // Inventory
        const inventoryDestination = document.getElementById(inventoryId);
        const inventorySource = html.getElementById(`inventory-${this.dataset.section}`);

        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        const inventory = document.getElementById(inventoryId);
        if (inventory) inventory.classList.remove('visibility-hidden');

        // Sku
        const skuDestination = document.getElementById(skuId);
        const skuSource = html.getElementById(`sku-${this.dataset.section}`);

        if (skuSource && skuDestination) skuDestination.innerHTML = skuSource.innerHTML;
        const sku = document.getElementById(skuId);
        if (sku) sku.classList.remove('visibility-hidden');

      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {

    const productForm = document.getElementById(`product-form-${this.productContainerId}`);

    if(productForm.getAttribute('data-location') === 'subscription-master') return;
    
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {

    const price = document.getElementById(`price-${this.productContainerId}`);
    const inventory = document.getElementById(`inventory-${this.productContainerId}`);
    const button = document.getElementById(`product-form-${this.productContainerId}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class SubscriptionOptions extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onPlanChange);
  }


  onPlanChange(event){
    let newSelection = event.target.value;
    this.sellingPlanId = newSelection;
    this.updateSellingPlanInput()
  }

  updateSellingPlanInput() {
    let quickviewContainer = document.querySelectorAll('[data-is-quickview="true"]');
    if(quickviewContainer.length > 0){
      this.productContainerId = `${this.dataset.section}-quickview`;
    } else {
      this.productContainerId = `${this.dataset.section}`;
    }

    const sellingPlanForm = document.querySelector(`#product-form-${this.productContainerId}`);
    const input = sellingPlanForm.querySelector('input[name="selling_plan"]');
    input.value = this.sellingPlanId;

    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return variant.options.every((option, index) => {
        return this.options[index] === undefined || this.options[index] === option;
      });
    });
  }

  getVariantData() {
    // Logic to retrieve variant data from your JSON or another source.
    return JSON.parse(document.querySelector('#product-json').textContent); // Assuming variants data is in a JSON script tag
  }

}

customElements.define('subscription-options', SubscriptionOptions);


class SubscriptionAddButton extends HTMLElement {
  constructor() {
    super();
  }
}

customElements.define('subscription-add-button', SubscriptionAddButton);




class RegionalOptions extends HTMLElement { 
  constructor() {
    super();
    this.addEventListener('input', this.onRegionalStateChange);
    this.selectContainer = this.querySelector('select');
    this.submitButton = this.querySelector('[id="get-started-link"]');
    this.selectLabel = this.querySelector('[id="state-select-label"]');
    this.regions = [
      {
        states: ["Alaska","Washington","Montana","Oregon","Idaho","Utah","Colorado","Wyoming","North Dakota","South Dakota","Nebraska","Kansas"],
        region: "pnwmtn"
      },
      {
        states: ["California","Nevada","Arizona","Hawaii"],
        region: "pacific-southwest"
      },
      {
        states: ["MN","Iowa","Missouri","Wisconsin","Illinois","Michigan","Ohio","Indiana"],
        region: "greatlakes"
      },
      {
        states: ["New Mexico","Texas","Oklahoma","Arkansas","Louisiana","Mississippi","Alabama","Tennessee","Kentucky","Georgia","South Carolina","North Carolina"],
        region: "south"
      },
      {
        states: ["District Of Columbia","New Hampshire","Rhode Island","West Virginia","Delaware","Vermont","Pennsylvania","New York","Connecticut","Maryland","Massachusetts","Virginia","New Jersey","Maine"],
        region: "northeast"
      },
      {
        states: ["Florida"],
        region: "florida"
      }
    ]

    this.handlePermission();
  }

  onRegionalStateChange(event){
    // Only run on our select menu
	if (event.target.id !== 'state-selector') return;

  this.findRegion(event.target.value)
  }

  getLocation() {
    fetch("https://ipinfo.io/json?token=a0950c7d77049e").then(
      (response) => response.json()
    ).then(
      (jsonResponse) => this.setLocation(jsonResponse.region)
    ).catch((error) => {
      this.setLocation("Georgia")
    })
  }

  setLocation(data){
    if(data !== undefined){
      this.selectContainer.value = data;
      this.findRegion(data)
    } else {
      this.selectContainer.value = "Georgia";
      this.findRegion("Georgia")
    }
  }

  handlePermission() {
    if (navigator.geolocation) {
      this.getLocation();
    } else { 
      this.findRegion(document.getElementById("state-selector").value);
    }
  }

  findRegion(selectValue){

    


    if(selectValue !== "Select your state"){
      this.selectedStateFullName = selectValue;
      let chosenRegion = this.regions.filter(function (e) {
        return e.states.includes(selectValue);
      });
      this.setRegion(chosenRegion[0].region)    
    } else {
      this.toggleButton();
    }
  }

  setRegion(region){
    this.matchingRegion = region;
    this.toggleButton(this.matchingRegion)
    this.updateLink(this.matchingRegion)
  }

  toggleButton(region){
    if(region !== undefined || null){
      this.submitButton.classList.remove("btn--inverse");
      this.selectContainer.classList.add("mb-select-dropdown__select-element--selected");
      this.selectLabel.style.display = "none";
    } else {
      this.submitButton.classList.add("btn--inverse");
      this.selectContainer.classList.remove("mb-select-dropdown__select-element--selected");
      this.selectLabel.style.display = "block";
    }
    // if(region === "Select your state"){
    //   console.log("Run")
    // }
  }

  updateLink(region){
    if(region !== undefined || null){
      this.submitButton.href = `/pages/region-${region}`;
    } else {
      this.submitButton.href = 'javascript:void(0)';
    }
  }

}

customElements.define('regional-options', RegionalOptions);




class RegionalProductOptions extends HTMLElement { 
  constructor() {
    super();
    // this.addEventListener('loft:Product:Variant__Changed', this.onVariantChange);
    this.addEventListener('input', this.onRegionalStateChange);
    this.selectContainer = this.querySelector('select');
    // this.submitButton = this.querySelector('[id="get-started-link"]');
    this.selectLabel = this.querySelector('[id="state-select-label"]');
    this.regions = [
      {
        states: ["Alaska","Washington","Montana","Oregon","Idaho","Utah","Colorado","Wyoming","North Dakota","South Dakota","Nebraska","Kansas"],
        region: "pnwmtn"
      },
      {
        states: ["California","Nevada","Arizona","Hawaii"],
        region: "pacific-southwest"
      },
      {
        states: ["MN","Iowa","Missouri","Wisconsin","Illinois","Michigan","Ohio","Indiana"],
        region: "greatlakes"
      },
      {
        states: ["New Mexico","Texas","Oklahoma","Arkansas","Louisiana","Mississippi","Alabama","Tennessee","Kentucky","Georgia","South Carolina","North Carolina"],
        region: "south"
      },
      {
        states: ["District Of Columbia","New Hampshire","Rhode Island","West Virginia","Delaware","Vermont","Pennsylvania","New York","Connecticut","Maryland","Massachusetts","Virginia","New Jersey","Maine"],
        region: "northeast"
      },
      {
        states: ["Florida"],
        region: "florida"
      }
    ]

    this.regionalOptionContainers = document.querySelectorAll('[data-region-id]');
    this.handlePermission();
  }

  onRegionalStateChange(event){
    // Only run on our select menu
	if (event.target.id !== 'state-selector') return;


  this.findRegion(event.target.value)
  }

  getLocation() {
    fetch("https://ipinfo.io/json?token=a0950c7d77049e").then(
      (response) => response.json()
    ).then(
      (jsonResponse) => this.setLocation(jsonResponse.region)
    )
  }

  setLocation(data){
    this.selectContainer.value = data;
    this.findRegion(data)
  }

  handlePermission() {
    if (navigator.geolocation) {
      this.getLocation();
    } else { 
      this.findRegion(document.getElementById("state-selector").value);
    }
  }
  

  findRegion(selectValue){

    this.selectedStateFullName = selectValue;
    let chosenRegion = this.regions.filter(function (e) {
      return e.states.includes(selectValue);
    });
    this.setRegion(chosenRegion[0].region) 
    
  }

  setRegion(region){
    this.matchingRegion = region;
    this.toggleOptions(this.matchingRegion);
  }

  toggleOptions(region){


    this.regionalOptionContainers.forEach(function(group){
      let currentRegion = group.getAttribute('data-region-id');
      if(currentRegion == region){
        group.style.display = "grid";
        group.setAttribute('data-region-active', 'true');
        group.querySelector('input').click();
      } else {
        group.setAttribute('data-region-active', 'false');
        group.style.display = "none";
      }
    })
  }

  toggleButton(region){
    if(region !== undefined || null){
      this.submitButton.classList.remove("btn--inverse");
      this.selectContainer.classList.add("mb-select-dropdown__select-element--selected");
      this.selectLabel.style.display = "none";
    } else {
      this.submitButton.classList.add("btn--inverse");
      this.selectContainer.classList.remove("mb-select-dropdown__select-element--selected");
      this.selectLabel.style.display = "block";
    }
  }

  updateLink(region){
    if(region !== undefined || null){
      this.submitButton.href = `/pages/region-${region}`;
    } else {
      this.submitButton.href = 'javascript:void(0)';
    }
  }

}

customElements.define('regional-product-options', RegionalProductOptions);





class ProductGifts extends HTMLElement { 
  constructor() {
    super();
    this.onVariantChange = this.onVariantChange.bind(this);
    this.gifts = this.querySelectorAll('[data-gift-variant-id]');
  }

  connectedCallback() {
    super.connectedCallback && super.connectedCallback();
    window.addEventListener('loft:Product:Variant__Changed', this.onVariantChange);
  }


  onVariantChange(event){

  const giftToShow = document.querySelector(`[data-gift-variant-id="${event.detail.id}"]`);

  if(giftToShow){
    this.gifts.forEach(function(gift){
      let currentGift = gift.getAttribute('data-gift-variant-id');
      if(currentGift == event.detail.id){
        gift.style.display = "flex";
      } else {
        gift.style.display = "none"
      }
    })

  }
}

}

customElements.define('product-gifts', ProductGifts);


document.addEventListener('rebuy:cart.change', function(event){   
   if(event.detail.cart.cart.item_count == 0){
    document.getElementById("cart-svg-count").innerHTML = event.detail.cart.cart.item_count;
    document.getElementById("cart-svg-count").classList.remove("cart-show");
   }else{
    document.getElementById("cart-svg-count").innerHTML = event.detail.cart.cart.item_count;
    document.getElementById("cart-svg-count").classList.add("cart-show");
   }
  }); 

  document.addEventListener('DOMContentLoaded', function () {
    async function fetchCart() {
      const response = await fetch('/cart.js');
      return response.json();
    }
  
    async function addItemToCart(id, quantity) {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: id,
          quantity: quantity,
          selling_plan: 2832335013
        }),
      });
      return response.json();
    }
  
    // Listen for the custom event that's triggered after something is added to the cart
    document.addEventListener('theme:ajaxCart:addSuccess', async function (e) { 
      const cart = await fetchCart();
      let hasSubscription = false;
      let combinedSubscriptionQuantity = 0;
      let specialProductQuantity = 0;
    
      for (let item of cart.items) {
        if (item.id == 42364536389797 || item.id == 42364536815781) {
          hasSubscription = true;
          combinedSubscriptionQuantity += item.quantity;
        }
        if (item.id == 43321625575589) {
          specialProductQuantity = item.quantity;
        } else {
          specialProductQuantity = 0;
        }
      }
      if (hasSubscription && specialProductQuantity < combinedSubscriptionQuantity) {       
        await addItemToCart('43321625575589', 1);
      }
    });
  
    const addToCartForms = document.querySelectorAll('form[action="/cart/add"]');
    addToCartForms.forEach(form => {
      form.addEventListener('submit', () => {
        setTimeout(() => { 
          const event = new CustomEvent('theme:ajaxCart:addSuccess');
          document.dispatchEvent(event);
        }, 1000); 
      });
    });
  });
